import {css} from 'lit';

export const clamLoginStyles = css`
    :host {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-height: 100dvh;
        box-sizing: border-box;
        padding: var(--clam-space-5, 20px);
        font-family: var(--clam-font, 'Inter', system-ui, -apple-system, sans-serif);
        color: var(--clam-darkgray, #424244);
        background: var(--clam-surface-soft, #f5f6f8);
    }

    .login-card {
        width: 100%;
        max-width: 380px;
        box-sizing: border-box;
        background: var(--clam-surface, #fff);
        border-radius: var(--clam-radius-lg, 12px);
        padding: var(--clam-space-7, 32px) var(--clam-space-6, 24px);
        box-shadow: var(--clam-shadow-md, 0 2px 8px rgba(0,0,0,0.10));
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .topbar { display: none; }

    .logo {
        width: clamp(80px, 25vw, 110px);
        height: clamp(80px, 25vw, 110px);
        object-fit: contain;
        margin-bottom: var(--clam-space-2, 8px);
    }

    .login-title {
        font-size: var(--clam-text-lg, 18px);
        font-weight: 700;
        color: var(--clam-darkgray, #424244);
        margin: 0 0 var(--clam-space-2, 8px);
        text-align: center;
    }

    .form {
        margin-top: var(--clam-space-3, 12px);
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .field {
        display: flex;
        align-items: flex-end;
        gap: var(--clam-space-2, 8px);
        width: 100%;
        max-width: 320px;
        border-bottom: 2px solid var(--clam-border, #e2e8f0);
        margin: var(--clam-space-2, 8px) 0;
        transition: border-color 0.2s ease;
    }
    .field:focus-within {
        border-bottom-color: var(--clam-light-green, #6bbb24);
    }

    .field__icon {
        color: var(--clam-green, #5a9d1e);
        width: 20px;
        height: 20px;
        margin-bottom: 7px;
        flex-shrink: 0;
    }

    .field input {
        flex: 1;
        border: none;
        background: transparent;
        font-size: var(--clam-text-base, 14px);
        font-family: inherit;
        padding: 8px 0;
        outline: none;
        color: var(--clam-darkgray, #424244);
        width: 100%;
        min-width: 0;
    }
    .field input::placeholder {
        color: var(--clam-light-gray, #898a8c);
    }

    .eye-btn {
        background: none;
        border: none;
        cursor: pointer;
        color: var(--clam-light-gray, #898a8c);
        padding: 0 6px 6px;
        font-size: var(--clam-text-xs, 11px);
        flex-shrink: 0;
        font-family: inherit;
        min-width: 40px;
        min-height: 40px;
    }
    .eye-btn:hover { color: var(--clam-green, #5a9d1e); }

    .btn {
        position: relative;
        transition: all 0.2s ease;
        margin: var(--clam-space-6, 24px) 0 var(--clam-space-4, 16px);
        padding: 12px var(--clam-space-7, 32px);
        font-size: var(--clam-text-base, 14px);
        font-family: inherit;
        font-weight: 600;
        border: none;
        border-radius: var(--clam-radius-md, 8px);
        cursor: pointer;
        background-color: var(--clam-light-green, #6bbb24);
        color: var(--clam-white, #fdfdfd);
        display: inline-flex;
        align-items: center;
        gap: var(--clam-space-2, 8px);
        width: 100%;
        max-width: 320px;
        justify-content: center;
    }
    .btn:hover { background-color: var(--clam-green, #5a9d1e); }
    .btn:disabled { opacity: 0.6; cursor: not-allowed; }

    .spinner {
        width: 18px;
        height: 18px;
        border: 2px solid rgba(255, 255, 255, 0.4);
        border-top-color: var(--clam-white, #fdfdfd);
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }

    @keyframes spin { to { transform: rotate(360deg); } }

    .alert {
        transition: all 0.3s ease;
        width: 100%;
        max-width: 320px;
        padding: var(--clam-space-2, 8px) var(--clam-space-4, 16px);
        border-radius: var(--clam-radius-sm, 6px);
        font-size: var(--clam-text-xs, 12px);
        margin: var(--clam-space-2, 8px) 0 0;
        color: var(--clam-white, #fdfdfd);
        text-align: center;
        line-height: 1.4;
    }
    .alert--error { background-color: var(--clam-danger, #ea4335); }
    .alert--success { background-color: var(--clam-success, #6bbb24); }

    .text {
        font-size: var(--clam-text-sm, 13px);
        color: var(--clam-darkgray, #424244);
        margin: var(--clam-space-1, 4px) 0 0;
        text-align: center;
        line-height: 1.5;
    }
    .text a {
        text-decoration: none;
        font-weight: 600;
        color: var(--clam-green, #5a9d1e);
    }
    .text a:visited { color: var(--clam-green-dark, #3f7a12); }

    .info {
        font-size: var(--clam-text-xs, 12px);
        color: var(--clam-gray, #6d6e71);
        line-height: 1.5;
        margin: var(--clam-space-2, 8px) 0;
        max-width: 320px;
        text-align: center;
    }

    .rules {
        list-style: none;
        margin: var(--clam-space-1, 4px) 0 0;
        padding: 0;
        width: 100%;
        max-width: 320px;
        display: flex;
        flex-direction: column;
        gap: 3px;
    }
    .rule { font-size: var(--clam-text-xs, 11px); }
    .rule--pass { color: var(--clam-green, #5a9d1e); }
    .rule--fail { color: var(--clam-light-gray, #898a8c); }

    .link-btn {
        background: none;
        border: none;
        cursor: pointer;
        color: var(--clam-green, #5a9d1e);
        font-weight: 600;
        font-size: var(--clam-text-sm, 13px);
        font-family: inherit;
        padding: 0;
    }
    .link-btn:hover { text-decoration: underline; }
`;
